import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {TankCertificate} from "./postCertificate";

export async function putCertificate(data: TankCertificate, uid: string) {
    const response = await axios.put<BaseResponse<boolean>>(`/tank/certificate/${uid}`, data)

    return response.data
}
